<label>
  <input
    type="checkbox"
    [attr.name]="name"
    [checked]="checked"
    [disabled]="disabled"
    [ngModel]="checked"
    (ngModelChange)="inputOnChange($event)"
  />
  <span><ng-content></ng-content></span>
</label>
